import React from 'react';
import Picture from "../Picture";

function DefaultLoader({ moduleType }) {
  return (
    <div data-testid={"loading"} className={`mls-o-loading mls-o-loading--${moduleType ? moduleType : "component"}`}>
      <Picture src={'/assets/images/MLS-simpleloader-200x200.gif'} />
    </div>
  );
}

export default DefaultLoader;
